import React from "react";
import { Avatar } from "@heroui/react";

interface HeroAvatarProps {
  src?: string;
  color?:
    | "default"
    | "primary"
    | "secondary"
    | "success"
    | "warning"
    | "danger";
  radius?: "none" | "sm" | "md" | "lg" | "full";
  size?: "sm" | "md" | "lg";
  name?: string;
  icon?: React.ReactNode;
  fallback?: React.ReactNode;
  isBordered?: boolean;
  isDisabled?: boolean;
  isFocusable?: boolean;
  showFallback?: boolean;
  ImgComponent?: React.ElementType;
  imgProps?: { [key: string]: any };
  classNames?: { [key: string]: string };
}

/**
 * HeroAvatar component renders an avatar with various customizable properties.
 *
 * @param {HeroAvatarProps} props - The properties for the HeroAvatar component.
 * @returns {JSX.Element} The rendered Avatar component.
 */
const HeroAvatar: React.FC<HeroAvatarProps> = ({
  src,
  color = "default",
  radius = "none",
  size = "md",
  name,
  icon,
  fallback,
  isBordered,
  isDisabled,
  isFocusable,
  showFallback,
  ImgComponent,
  imgProps,
  classNames,
}) => {
  return (
    <Avatar
      src={src}
      color={color}
      radius={radius}
      size={size}
      name={name}
      icon={icon}
      fallback={fallback}
      isBordered={isBordered}
      isDisabled={isDisabled}
      isFocusable={isFocusable}
      showFallback={showFallback}
      ImgComponent={ImgComponent}
      imgProps={imgProps}
      classNames={classNames}
    />
  );
};

export default HeroAvatar;
